var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5V19.5C3 18.4391 3.42143 17.4217 4.17157 16.6716C4.92172 15.9214 5.93913 15.5 7 15.5H11C12.0609 15.5 13.0783 15.9214 13.8284 16.6716C14.5786 17.4217 15 18.4391 15 19.5V21.5M16 3.63C16.8604 3.8503 17.623 4.3507 18.1676 5.05231C18.7122 5.75392 19.0078 6.61683 19.0078 7.505C19.0078 8.39317 18.7122 9.25608 18.1676 9.95769C17.623 10.6593 16.8604 11.1597 16 11.38M21 21.5V19.5C20.9949 18.6172 20.6979 17.7608 20.1553 17.0644C19.6126 16.368 18.8548 15.8707 18 15.65M5 7.5C5 8.56087 5.42143 9.57828 6.17157 10.3284C6.92172 11.0786 7.93913 11.5 9 11.5C10.0609 11.5 11.0783 11.0786 11.8284 10.3284C12.5786 9.57828 13 8.56087 13 7.5C13 6.43913 12.5786 5.42172 11.8284 4.67157C11.0783 3.92143 10.0609 3.5 9 3.5C7.93913 3.5 6.92172 3.92143 6.17157 4.67157C5.42143 5.42172 5 6.43913 5 7.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUser);
export default __webpack_public_path__ + "static/media/nav_user.66f8adc6f7e070c4b55b0d0a91708328.svg";
export { ForwardRef as ReactComponent };